export default __webpack_public_path__ + "5eea923608d877d105f3a4527fc36e90.png";